// image 
// title
// subtitle
// button

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { config } from "../config";


const navbarHeight = config.navbarHeight

export default function FullScreenBox({ title, subtitle, buttons, img }) {
  return (
    <Box
      sx={{
        position: "relative", 
        width: "100vw",
        height: '90vw',
        maxHeight: '90vh',
        overflow: "hidden",
        marginTop: {
          xs: navbarHeight,
          lg: 0
        },
      }}
    >
      <Box
        component="img"
        src={img}
        alt="Background"
        sx={{
          width: "100%", 
          height: "100%", 
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1, 
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2, 
          display: "flex", 
          flexDirection: "column",
          alignItems: "center", 
          justifyContent: "center",
          height: "100%", 
          color: "white", 
          textAlign: "center", 
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          gap: 2
        }}
      >
        <Typography 
        sx={{
          fontSize: {
            xs: 20,
            sm: 30,
            md: 50,
          },
          fontWeight: "bold", 
          lineHeight: 1.2, 
          textTransform: "uppercase", 
          mb: 2,
        }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography variant="h5" sx={{ mb: 4 }}>
            {subtitle}
          </Typography>
        )}

        <Box 
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2, 
            flexDirection:{
              xs: "column",
              sm: "column",
              md: "row",
              }
            }}
        >

        {buttons?.map((b, index) => (
          <Button
            key={index} 
            variant="contained"
            color="primary"
            size="large"
            href={b?.link}
            sx={{
              fontWeight: "bold",
              borderRadius: 2,
              '&:hover':{
                color: 'white'
              }
            }}
          >
            {b.label}
          </Button>
        ))}
        </Box>
      </Box>
    </Box>
  );
}
